import $ from 'jquery'

$(document).ready(function() {
  co_vc_oil_request()
})

function co_vc_oil_request() {
  $('.co_vc_oil_request').each(function() {})
}
